import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ExtensibleMessagingCard } from '@shared-ui/retail-lodging-extensible-messaging-card';

import { IconSize } from 'src/common/__generated__/api';
import { MessagingCard } from 'components/common/messaging-card/messaging-card';
import { MessagingCardOverFilteredPills } from './messaging-card-overfiltered-pills';
import { MessagingCardProps } from './messaging-card';

interface OverfilteredMessagingCardProps extends MessagingCardProps {
  model: any;
}

export const OverfilteredMessagingCard: React.FC<OverfilteredMessagingCardProps> = ({ model, ...rest }) => {
  const overFilteredData = {
    title: {
      ...model?.titleModel,
      icon: {
        id: 'search',
        size: IconSize.LARGE,
        withBackground: true,
      },
    },
    subtitle: {
      ...model?.subtitleModel,
    },
    __typename: model?.type,
  };

  return (
    <Experiment name="Small_Crafts_over_filtered_state_messaging">
      <ExperimentControl>
        <MessagingCard model={model} {...rest} />
      </ExperimentControl>
      <ExperimentVariant bucket={1}>
        <ExtensibleMessagingCard data={overFilteredData} background="primary">
          <MessagingCardOverFilteredPills />
        </ExtensibleMessagingCard>
      </ExperimentVariant>
      <ExperimentVariant bucket={2}>
        <ExtensibleMessagingCard data={overFilteredData} background="primary">
          <MessagingCardOverFilteredPills />
        </ExtensibleMessagingCard>
      </ExperimentVariant>
    </Experiment>
  );
};
